import { DYNAMIC_TOOL_TYPE, TOOL_TYPE_PREFIX } from '../constants/toolParts';

import type IAiChatMessagePart from 'store/slices/aiChats/interfaces/IAiChatMessagePart';

/**
 * Name of the tool a part calls, or null when the part is not a tool call.
 *
 * An empty string is a tool call whose name never arrived — still a call, and still listed, but
 * with nothing to name it by.
 */
const readToolName = (part: IAiChatMessagePart): string | null => {
  if (part.type === DYNAMIC_TOOL_TYPE) {
    return part.toolName || '';
  }

  return part.type.startsWith(TOOL_TYPE_PREFIX)
    ? part.type.slice(TOOL_TYPE_PREFIX.length)
    : null;
};

export default readToolName;
